import type { FindingRow } from "../types";
import type { SelectedEntityWithFindingData } from "~/components/exceptions/SetExceptionDialog";
import type { SelectedEntityWithException } from "~/components/exceptions/types";

export function buildSelectedEntity(
  finding: FindingRow,
): SelectedEntityWithFindingData & SelectedEntityWithException {
  return {
    mrn: finding.mrn,
    exception: finding.exception,
    title: finding.title || finding.id,
    rating: finding.rating ?? undefined,
    type: finding.__typename as
      | "CheckFinding"
      | "CveFinding"
      | "AdvisoryFinding"
      | "GenericFinding",
  };
}

export function buildExceptionTargetData(
  assetId: string,
  assetMrn?: string,
  assetName?: string,
) {
  return {
    targetTitle: assetName,
    onAsset: assetMrn
      ? {
          id: assetId,
          mrn: assetMrn,
          name: assetName || "",
          __typename: "EntityInfoAsset" as const,
        }
      : undefined,
  };
}

export function getFirstCaseMrn(finding: FindingRow): string | undefined {
  return finding.cases?.edges?.[0]?.node?.mrn;
}

export function isFixableFinding(finding: FindingRow): boolean {
  return ["CveFinding", "AdvisoryFinding"].includes(finding.__typename);
}
